import React from "react";
import { AppBar, Toolbar, Link } from "@material-ui/core";
import { useHistory } from "react-router-dom";

import {
  makeStyles,
  createTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import User from "../images/user-icon.svg";
import Logo from "../images/flyins-logo.svg";
import Localization from "./Localization";
import { withRouter } from "react-router-dom";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import SearchInput from "./Search";
import ArrowDownIcon from "./ArrowDownIcon";
import { useUserContext } from "../contexts/userContext";

const { Option } = Select;

const selectStyle = (color) => ({
  fontSize: 13,
  fontWeight: 400,
  width: "auto",
  minWidth: 90,
  color,
  ".ant-select-arrow": {
    color,
  },
});

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    height: 79,
    padding: "10px 0",
  },
  headerContent: {
    width: "100%",
    maxWidth: 1280,
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
  },
  logo: {
    marginRight: theme.spacing(2),
    width: 147,
  },
  spacer: {
    flexGrow: 1,
  },
}));

const theme = createTheme({
  overrides: {
    MuiAppBar: {
      colorPrimary: {
        backgroundColor: "#fff",
      },
    },
    MuiPaper: {
      elevation4: {
        boxShadow: "none !important",
      },
    },
  },
});

const Header = withRouter(({ location }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const classes = useStyles();
  const currentPath = location.pathname;
  const { user, isLoading } = useUserContext();
  const userEmail = isLoading ? "" : user?.email || "";

  const filteredPaths = [
    "/forgotpassword",
    "/login",
    "/createaccount",
    "/verify/resetpassword",
    "/resetpassword",
  ];

  const isAuthenticatedPath = filteredPaths.every(
    (path) => !currentPath.includes(path)
  );

  return (
    isAuthenticatedPath && (
      <ThemeProvider theme={theme}>
        <AppBar position="fixed" className={classes.appBar}>
          <Toolbar>
            <div className={classes.headerContent}>
            <Link href="/">
              <img src={Logo} alt="Logo" className={classes.logo} />
            </Link>
            <div
              style={{
                width: "100%",
                display: currentPath !== "/" ? "flex" : "none",
                alignItems: "center",
              }}
            >
              <SearchInput maxWidth={796} />
            </div>

            <div className={classes.spacer} />
            <Localization />
            <img src={User} alt="User" />
            <Select
              className="user-drawer"
              style={{ ...selectStyle }}
              dropdownStyle={{ border: 0 }}
                value={userEmail}
                disabled={isLoading}
              bordered={false}
                suffixIcon={<ArrowDownIcon />}
              onChange={() => {
                localStorage.clear();
                  window.dispatchEvent(new Event("auth-change"));
                history.push(`/login`);
              }}
              color={"#3A3F47"}
            >
              <Option value="logout">{t("LogOut")}</Option>
            </Select>
            </div>
          </Toolbar>
        </AppBar>
      </ThemeProvider>
    )
  );
});

export default Header;
